import http from "@/utils/request"

/**
 * 获取老人信息
 * @param {Object} data 查询参数
 * @param {String} data.id 按ID检索，可为空
 * @param {String} data.name 按姓名模糊检索，可为空
 * @returns {Promise} 返回包含老人列表的Promise
 */
export function getUserinfo(data){
    return http({
        url:'/aea/elder/list',
        method:'get',
        params: data
    })
}

//查询护理时间线
export function timeLine(data){
    return http({
        url:'/care/timeSlots/timeline',
        method:'post',
        data
    })
}

//生成计划
export function adjust(data){
    return http({
        url:'/elderDemand/adjust',
        method:'post',
        data
    })
}


